export default "tr";